import { render, staticRenderFns } from "./productAdd.vue?vue&type=template&id=418449bc&scoped=true"
import script from "./productAdd.vue?vue&type=script&lang=js"
export * from "./productAdd.vue?vue&type=script&lang=js"
import style0 from "./productAdd.vue?vue&type=style&index=0&id=418449bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418449bc",
  null
  
)

export default component.exports